<template>
  <div class="time_nav">
    <ul class="clearfix">
      <li v-for="(v, i) in yearList" :key="i" :class="{'odd': i %2 == 0, 'even': i %2 != 0, 'active': yearIndex == i}" @click="changeYear(i)">
        <span class="year_con">
          {{v.value}}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      yearList: [
        {
          value: '2015年'
        },
        {
          value: '2016年'
        },
        {
          value: '2017年'
        },
        {
          value: '2018年'
        },
        {
          value: '现在'
        }
      ],
      yearIndex: 0
    }
  },
  created () {
    // this.changeYear(this.$route.query.year)
  },
  watch: {
    '$router': {
      handler () {
        this.yearIndex = this.$route.query.year || 0
      },
      immediate: true
    }
  },
  methods: {
    changeYear (i) {
      if (i == 4) return
      this.yearIndex = i
      this.$emit('changeYear', this.yearIndex)
    }
  },
}
</script>

<style scoped lang="scss">
.time_nav {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: .47rem;
  ul {
    width: max-content;
    margin-top: 1.4rem;
    padding-bottom: 1rem;
    li {
      background: #7377f3;
      float: left;
      font-size: .39rem;
      font-weight: bold;
      width: 4rem;
      height: .2rem;
      margin-right: .06rem;
      text-align: center;
      position: relative;
      color: #7377f3;
      cursor: pointer;
      .year_con {
        position: relative;
        top: -.8rem;
      }
      &.odd {
        &::before {
          content: '';
          display: inline-block;
          width: 0;
          height: 0;
          border-left: .2rem solid transparent;
          border-right: .2rem solid transparent;
          border-bottom: .21rem solid #7377f3;
          position: absolute;
          top: -.21rem;
          left: 50%;
          margin-left: -.3rem;
        }
      }
      &.even {
        &::before {
          content: '';
          display: inline-block;
          width: 0;
          height: 0;
          border-left: .2rem solid transparent;
          border-right: .2rem solid transparent;
          border-top: .21rem solid #7377f3;
          position: absolute;
          bottom: -.21rem;
          left: 50%;
          margin-left: -.3rem;
        }
        .year_con {
          position: relative;
          top: .6rem;
        }
      }
      &:first-child {
        border-radius: 8px 0px 0px 8px;
      }
      &:last-child {
        margin-right: 0;
        border-radius: 0px 8px 8px 0px;
        background: #9b8fa4;
        color: #9b8fa4;
        &::before {
          content: '';
          border-bottom: .21rem solid #9b8fa4;
        }
      }
      &.active {
        background: #0b2ab0;
        color: #0b2ab0;
        &.odd {
          &::before {
            border-bottom: .21rem solid #0b2ab0;
          }
        }
        &.even {
          &::before {
            border-top: .21rem solid #0b2ab0;
          }
        }
      }
    }
  }
}
</style>
